<template>
  <div id="intro-3" class="intro-box">
    <div class="intro-box__wrapper">
      <div class="intro-box__header">
        <h3>Commission Start Date</h3>
      </div>

      <div class="intro-box__content">
        <p>Congratulations! Your commissions have been configured. You can always modify the
          settings later.</p>

        <p>Now that the commissions have been configured when would you like to start tracking
          sales?</p>

        <div class="intro-box__actions">
          <div class="form-field">
            <label class="show-for-sr" for="start-date">Commission Start Date</label>

            <datepicker :id="'start-date'"
                        :format="dateFormat"
                        :clear-button="true"
                        :placeholder="'Dec 31, 2099'"
                        @cleared="commissionDateSelected"
                        @selected="commissionDateSelected"></datepicker>
          </div>
        </div>

        <div class="intro-box__action-helper">
          <p>If left blank we will track all orders ever placed.</p>
        </div>
      </div>
    </div>

    <div class="intro-box__footer">
      <div class="grid-x grid-padding-x">
        <div class="cell auto">
          <button class="button--wide button--alt" @click="changeStep(false)">Back</button>
        </div>

        <div class="cell auto">
          <button :class="['button--wide', chosen === null ? 'disabled': '']" @click="changeStep">
            Next
          </button>
        </div>
      </div>

<!--      <div class="intro-box__skip">configure later</div>-->
    </div>

    <div class="intro-box__pagination">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span class="active"></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  mixins: [
    client
  ],
  components: {
    Datepicker
  },
  data: function () {
    return {
      chosen: true,
      commissionDate: ''
    }
  },
  methods: {
    dateFormat (date) {
      return moment(date).format('MMM D, YYYY')
    },
    commissionDateSelected (date) {
      this.commissionDate = date
    },
    choose (choice) {
      this.chosen = choice
    },
    async change () {
      if (this.commissionDate !== undefined && this.commissionDate !== null && this.commissionDate !== '') {
        await this.$store.dispatch(
          'updateAppSettings', {
            commission_start_date: moment(this.commissionDate).format('YYYY-MM-DDT00:00:00')
          }
        )
      } else {
        await this.$store.dispatch(
          'updateAppSettings', {
            commission_start_date: null
          }
        )
      }
    },
    changeStep (next = true) {
      this.change()

      this.$emit('changeStep', next)
    }
  }
}
</script>

<style lang="scss">
  @import '../../../styles/mixins';
  @import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/step6.vue